<template>
  <div :class="[$style.container, { [$style.open]: isOpen }]">
    <div :class="$style.tabs">
      <div :class="[$style.tab, { [$style.open]: activeTab === 'all' }]" @click="setTab('all')">
        All
      </div>
      <div :class="[$style.tab, { [$style.open]: activeTab === 'teams' }]" @click="setTab('teams')">
        TEAMS
      </div>
    </div>

    <neutral-list v-show="activeTab === 'all'" :categories="neutrals" />
    <neutral-teams v-show="activeTab === 'teams'" :categories="neutrals" />

    <div :class="$style.close" @click="close">
      Close <font-awesome :class="$style.ficon" icon="fa-close" />
    </div>
  </div>
</template>

<script>
import NeutralList from './neutral-list.vue'
import NeutralTeams from './neutral-teams.vue'

export default {
  name: 'neutrals',
  components: { NeutralList, NeutralTeams },
  data() {
    return {
      activeTab: 'all'
    }
  },
  computed: {
    isOpen() {
      return this.$store.getters.shopkeeper === 'neutrals'
    },
    neutrals() {
      return this.getShopkeeperItems('neutrals')
    }
  },
  methods: {
    setTab(tab) {
      this.activeTab = tab
    },
    close() {
      this.$store.commit('SetShopkeeper', null)
    }
  }
}
</script>

<style lang="scss" module>
.container {
  position: absolute;
  right: -30vw;
  bottom: 15vw;
  width: 22vw;
  height: 30vw;
  background: linear-gradient(180deg, rgba(#162024, 0.95) 40%, rgba(#162024, 0.8) 100%);
  box-shadow: 0 0.05vw 0.2vw rgba(var(--color_black-rgb), 0.5);
  border: 0.2vw solid rgba(var(--color_black-rgb), 0.5);
  border-radius: 0.3vw;
  z-index: 50;
  opacity: 0;
  transition: opacity ease 0.5s, right ease 0.5s;

  &.open {
    opacity: 1;
    right: 6vw;
  }
}

.tabs {
  position: absolute;
  bottom: 100%;
  display: flex;
  gap: 0.3vw;
  margin-left: 0.2vw;
}

.tab {
  background: linear-gradient(180deg, rgba(#242424, 0.95) 40%, rgba(#242424, 0.8) 100%);
  border: 0.2vw solid rgba(var(--color_black-rgb), 0.5);
  padding: 0.3vw 1vw 0.2vw 1vw;
  border-radius: 0.4vw 0.4vw 0 0;
  color: white;
  font-size: 0.9vw;
  text-transform: uppercase;
  cursor: pointer;

  &:hover {
    text-shadow: text-shadow(gba(var(--color-primary, 0.6)), 0.2vw);
  }

  &.open {
    background: linear-gradient(180deg, rgba(#162024, 0.95) 40%, rgba(#162024, 0.8) 100%);
    border-bottom: none;
    text-shadow: text-shadow(gba(var(--color-primary, 0.4)), 0.2vw);
  }
}

.content {
  flex: 1;
  border-top: 0.2vw solid rgba(var(--color_black-rgb), 0.8);
}

.label {
  color: rgba(white, 0.6);
  text-transform: uppercase;
  font-size: 0.65vw;
  padding: 0.4vw 1.2vw;
}

.close {
  position: absolute;
  top: -1.9vw;
  right: 0;
  text-transform: uppercase;
  text-shadow: none;
  font-weight: bold;
  color: var(--color_white);
  font-size: 0.8vw;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.3vw 0.6vw;
  border-radius: 0.2vw;
  background: rgba(rgb(143, 0, 0), 0.8);
  cursor: pointer;

  &:hover {
    transition: all ease 0.5s;
    background: rgba(rgb(143, 0, 0), 1);
  }

  .ficon {
    margin-left: 0.4vw;
    font-size: 1vw;
  }
}
</style>
